import { Navigate } from 'react-router-dom'
import { RouteInterface } from './interfaces'

export default function PrivateRoute({
  children,
  redirectTo,
  isAuthenticated
}: RouteInterface) {
  return isAuthenticated ? children : <Navigate to={redirectTo} />
}
